import { render, staticRenderFns } from "./SysLogFile.vue?vue&type=template&id=edcf20aa&scoped=true&"
import script from "./SysLogFile.vue?vue&type=script&lang=js&"
export * from "./SysLogFile.vue?vue&type=script&lang=js&"
import style0 from "./SysLogFile.vue?vue&type=style&index=0&id=edcf20aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edcf20aa",
  null
  
)

export default component.exports